module.exports = __webpack_public_path__ + "media/img/payments/web-icon-28679acc12de7b52f4617fd82411062a.svg";